import React, { Component } from 'react';
import PropTypes from 'prop-types';
import styled from 'react-emotion';
import { Link } from 'gatsby';
import { ProjectCategories } from 'components/ProjectListing';
import Img from 'gatsby-image';

const Item = styled.div`
  padding: 0rem 1rem 0.5rem 1rem;
  position: relative;
  width: 33%;
  @media (max-width: ${props => props.theme.breakpoints.l}) {
      width: 33%;
  }
  @media (max-width: ${props => props.theme.breakpoints.m}) {
      width: 33%;
  }
  @media (max-width: ${props => props.theme.breakpoints.s}) {
      width: 100%;
  }
  font-size: 12px;
  div.noscript {
    display: block;
  }
`;

const ProjectCategory = styled.div`
  font-size: 0.5rem;
  padding-bottom: 0.25rem;
`;

const Client = styled.p`
  margin: 1rem 0 0.5rem 0;
  padding-left: 0.25rem;
  padding-bottom: 0.25rem;
  a {
    font-style: normal;
    font-weight: normal;
  }
`;

const Title = styled.div`
  margin-top: 0.5rem;
  color: ${props => props.theme.colors.black};
  font-size: 1rem;
  font-weight: 700;
  p {
    margin-bottom: 0.5rem;
  }
`;

const ProjectSummary = styled.p`
  margin-bottom: 2rem;
`;

const ProjectLink = styled(Link)`
  font-style: normal;
  font-weight: normal;
  color: ${props => props.theme.colors.black};
`;

const MoreLink = styled(Link)`
  position: absolute;
  bottom: 0;
  font-style: normal;
  text-decoration: underline;
  color: ${props => props.theme.colors.lightBlue};
  font-weight: normal;
`;

const ProjectThumbnail = styled(Img)`
`;

export default class ProjectListItem extends Component {
  render() {
    const { node, projectcategories } = this.props;
    return (
      <Item>
        <Link to={node.uid}><ProjectThumbnail fluid={node.data.thumbnail.localFile.childImageSharp.fluid} /></Link>
        <Client>
          Client: {node.data.client.text}
        </Client>
        <ProjectCategory>
         {projectcategories && <ProjectCategories projectcategories={projectcategories} />}
        </ProjectCategory>
        <ProjectLink to={node.uid}>
          <Title>
            <p>{node.data.title.text}</p>
          </Title>
          <ProjectSummary>
            {node.data.summary.text}
          </ProjectSummary>
        </ProjectLink>
        <MoreLink to={node.uid}>
          <p>More</p>
        </MoreLink>
      </Item>
    );
  }
}

ProjectListItem.propTypes = {
  node: PropTypes.object.isRequired,
  projectcategories: PropTypes.array.isRequired,
};
